import { Drawer } from '@mui/material'

type Props = {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

export const previewCloseExceptionClass = 'preview-close-exception'

export const MenuDrawer = ({ isOpen, onClose, children }: Props) => {
  return (
    <Drawer
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 360 },
          pt: '76px',
          pl: 3,
          pb: 3.5,
        },
      }}
      anchor="right"
      variant="temporary"
      onClose={onClose}
      open={isOpen}
    >
      {children}
    </Drawer>
  )
}
